<template>
    <div>
      <arksnackbar v-model="status" ></arksnackbar>
      <v-autocomplete
        hide-details 
        cache-items
        append-icon="search"
        :label="label"
        :loading="status.loading"
        :items="items"
        item-text="isimAra"
        item-value="id"
        :search-input.sync="search"
        v-model="Model"
        return-object
        :required="required" 
        :rules="rules"
        :readonly=false
        
      >

      

      </v-autocomplete>
    </div>
</template>

<script>
import tool from "../tools";
import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";

export default {
  props: ["value", "apiname", "label", "tip", "required", "rules"],
  components: {
    arksnackbar
  },
  computed: {
    Model: {
      get: function() {
        var r = { id: "", isim: "", kod: "", isimAra: "" };
        if (
          this.value != undefined &&
          this.value != null &&
          this.value.id != null
        ) {
          r = {
            id: this.value.id,
            isim: this.value.isim,
            kod: this.value.kod,
            isimAra: this.IsimAra(this.value)
          };
        }
        this.SetItems(r);
        return r;
      },
      set: function(newValue) {
        if (newValue == null) {
          newValue = { id: "", isim: "", kod: "", isimAra: "" };
        }
        this.$emit("input", newValue);
      }
    }
  },

  data() {
    return {
      loading: false,
      items: [],
      search: null,
      status: tool.NewSatatus(),
      ayrac: "  -  "
    };
  },

  watch: {
    search(val) {
      if (val != undefined && val == "") {
        this.items = [{ id: "", isim: "", kod: "", isimAra: "" }];
        this.Model = { id: "", isim: "", kod: "", isimAra: "" };
      } else {
        val &&
          val.indexOf(this.ayrac) == -1 &&
          val.length > 1 &&
          this.querySelections(val);
      }
    }
  },
  methods: {
    querySelections(v) {
      var prm = {
        id: "",
        kod: "",
        aciklama: v,
        tip: this.tip
      };
      setTimeout(() => {
        this.Ara(prm);
      }, 400);
    },

    IsimAra(v) {
      return (
        v.isim.replace(this.ayrac, "-") +
        this.ayrac +
        v.kod.replace(this.ayrac, "-")
      );
    },
    SetItems(v) {
      if (v.id != null && v.id.length > 0) {
        this.items = [v];
      } else {
        this.items = [];
      }
    },

    Ara(prm) {
      this.status.loading = true;
      tool.http_post(this, this.apiname, prm).then(
        response => {
          this.items = [];
          for (var i = 0; i < response.body.length; i++) {
            this.items.push({
              id: response.body[i].id,
              isim: response.body[i].isim,
              kod: response.body[i].kod,
              isimAra: this.IsimAra(response.body[i])
            });
          }

          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );
    }
  }
};
</script>